





































import { Vue, Component, Prop } from "vue-property-decorator";
import { UserInfo } from "../../_models/userInfo";
import { bus } from "../../main";
import EditUserInfoStepper from "../Edit/EditUserInfoStepper.vue";
import EditEnterpriseInfoStepper from "../Edit/EditEnterpriseInfoStepper.vue";
import EditInstituteInfoStepper from "./EditInstituteInfoStepper.vue";
import EditStudentInfoStepper from "./EditStudentInfoStepper.vue";
import EditRichiestaAlternanza from "./EditRichiestaAlternanza.vue";
import EditUserRoles from "./EditUserRoles.vue";
import EditQuestionarioColloquio from "./EditQuestionarioColloquio.vue";
import EditRichiestaTirEstivo from "./EditRichiestaTirEstivo.vue";
import EditAssicurazineIstituto from "./EditAssicurazioneIstituto.vue";
import EditAttivita from "./EditAttivita.vue";
import EditPreferenzaWorkshop from "./EditPreferenzaWorkshop.vue";
import EditOffertaLavoro from "./EditOffertaLavoro.vue";
import EditContattoAzienda from "./EditContattoAzienda.vue";
import EditNotaAzienda from "./EditNotaAzienda.vue";
import EditTirFormativo from "./EditTirFormativo.vue";
import EditApprendistato from "./EditApprendistato.vue";

@Component({
	components: {
		EditUserInfoStepper,
		EditEnterpriseInfoStepper,
		EditInstituteInfoStepper,
		EditStudentInfoStepper,
		EditRichiestaAlternanza,
		EditUserRoles,
		EditQuestionarioColloquio,
		EditRichiestaTirEstivo,
		EditAssicurazineIstituto,
		EditAttivita,
		EditPreferenzaWorkshop,
		EditOffertaLavoro,
		EditContattoAzienda,
		EditNotaAzienda,
		EditTirFormativo,
		EditApprendistato
	}
})
export default class EditDialog extends Vue {
	@Prop() selector!: string;
	@Prop() info!: any;
	@Prop() checkInfo!: any;
	@Prop() idIstituto!: number;
	private dialog: boolean;

	constructor() {
		super();
		this.dialog = false;
	}

	created() {
		bus.$on("closeEditDialog", () => {
			this.dialog = false;
		});
	}
}
